export const formatDateLongString = (dateString) => {
  const date = new Date(dateString);
  const months = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ];
  const monthName = months[date.getMonth()];
  const year = date.getFullYear();
  return `${monthName} ${year}`;
}

export const dateDifference = (date1, date2, unit) => {
  if (unit === 'month') {
    return (
      date2.getFullYear() * 12 +
      date2.getMonth() -
      (date1.getFullYear() * 12 + date1.getMonth())
    );
  } else if (unit === 'year') {
    return date2.getFullYear() - date1.getFullYear();
  }
  return 0;
}

export const addYearsToDate = (date, years) => {
  const newDate = new Date(date);
  newDate.setFullYear(newDate.getFullYear() + years);

  // Handle leap year edge case for February 29th
  if (date.getMonth() === 1 && date.getDate() === 29 && !isLeapYear(newDate.getFullYear())) {
    newDate.setDate(28); 
  }

  return newDate;
};

function isLeapYear(year) {
  return (year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0));
}